(() => {
  function init(root) {
    if (root.dataset.wf26Ready) return;
    root.dataset.wf26Ready = 'true';
    root.querySelectorAll('[data-benefit-check]').forEach(panel => {
      const input = panel.querySelector('[data-beneficiary-id]');
      const status = panel.querySelector('[data-benefit-status]');
      const validateButton = panel.querySelector('[data-benefit-validate]');
      const resultPanel = panel.querySelector('[data-benefit-result]');
      const kind = panel.querySelector('[data-benefit-kind]');
      const cartButton = panel.querySelector('[data-benefit-cart]');
      let benefit;
      const validate = async () => {
        if (validateButton.disabled) return;
        benefit = undefined;
        resultPanel.hidden = true;
        if (!input.value.trim()) {
          status.textContent = 'Ingresa tu cédula para continuar.';
          input.focus();
          return;
        }
        validateButton.disabled = true;
        status.textContent = 'Consultando tu beneficio…';
        try {
          const response = await fetch('https://power-club-eight.vercel.app/api/wellfest/benefit', {
            method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',
            body:JSON.stringify({identifier:input.value.trim(),kind:kind.value})
          });
          const data = await response.json();
          const messages = {
            setup:'Estamos terminando la activación del beneficio. Vuelve a consultar pronto.',
            unavailable:'No encontramos un beneficio disponible para esta cédula. Verifica el número o consulta con Power Club.',
            redeemed:'Esta cédula ya usó su beneficio de WellFest. Puedes comprar otra entrada a precio normal.',
            sales_pending:'Tu beneficio está pendiente de la apertura de ventas. Todavía no se ha usado.',
            review:'Tu beneficio necesita una revisión de Power Club. No se ha generado un nuevo descuento.',
          };
          if (response.ok && data.state === 'ready') {
            benefit = data;
            kind.value = data.kind;
            status.textContent = `Beneficio disponible para ${data.kind === 'class' ? 'clases especiales' : 'competencia'}. Una entrada sin costo. Se redime al completar el pedido.`;
            resultPanel.hidden = false;
          } else status.textContent = messages[data.state] || data.message || 'No pudimos validar. Inténtalo nuevamente.';
        } catch { status.textContent = 'No pudimos conectar con la validación. Inténtalo nuevamente.'; }
        finally { input.value = ''; validateButton.disabled = false; }
      };
      validateButton.addEventListener('click', validate);
      kind.addEventListener('change', () => { benefit=undefined;resultPanel.hidden=true; });
      cartButton.addEventListener('click', async () => {
        if (!benefit || cartButton.disabled) return;
        cartButton.disabled=true;
        const items=[{id:benefit.variantId,quantity:1}];
        if (panel.querySelector('[data-benefit-shirt]').checked) items.push({id:benefit.shirtVariantId,quantity:1});
        try {
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('cart');
          location.assign('/discount/'+encodeURIComponent(benefit.code)+'?redirect='+encodeURIComponent('/cart'));
        } catch {
          status.textContent='No pudimos confirmar el carrito. Revísalo antes de volver a agregar entradas; tu beneficio no se ha consumido.';
          cartButton.disabled=false;
        }
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); validate(); }
      });
    });
    // Carry only Shopify's draft preview ID across the three landing routes.
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) root.querySelectorAll('[data-wf26-link]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.href; }
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.animate([{opacity:0,transform:'translateY(22px)'},{opacity:1,transform:'translateY(0)'}], {duration:600,easing:'ease-out'});
        observer.unobserve(entry.target);
      }), {threshold:0.12});
      root.querySelectorAll('.wf26-live-methods a, .wf26-live-cards .wf26-how-grid > *').forEach(el => observer.observe(el));
    }
    root.querySelectorAll('[data-class-benefit-open]').forEach(button => button.addEventListener('click', () => {
      const classSelector = root.querySelector('[data-class-selector]');
      classSelector?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
      setTimeout(() => classSelector?.querySelector('[data-class-special]')?.focus({preventScroll:true}), 350);
    }));
    root.querySelectorAll('[data-competition-benefit-open]').forEach(button => button.addEventListener('click', () => {
      const competitionType = root.querySelector('select[name="properties[Tipo de competencia]"]');
      competitionType?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
      setTimeout(() => competitionType?.focus({preventScroll:true}), 350);
    }));
    root.querySelectorAll('[data-method]').forEach(link => link.addEventListener('click', () => {
      const select = root.querySelector('select[name="properties[Clase especial]"]');
      if (select) { select.value = link.dataset.method; select.dispatchEvent(new Event('change', {bubbles:true})); }
    }));
  }
  document.querySelectorAll('.wf26').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.wf26').forEach(init));
})();
